import Vue, {
    ref, computed, unref, watch, toRefs,
} from 'vue';
import useVueProxy from '@ve/services/useVueProxy';

import { IHotelOfferTariffs, IHotelOfferTariff } from './types';

export default (props: IHotelOfferTariffs, {
    ctx,
}: {
    ctx: Vue | undefined
}) => {
    const { $root } = useVueProxy();
    const { tariffs } = toRefs(props);
    const selectedTariff = ref<IHotelOfferTariff | null>(null);
    const quoteInProgress = ref(false);

    watch(tariffs, () => {
        selectedTariff.value = null;
        quoteInProgress.value = false;
    });

    const currentTariff = computed(() => unref(selectedTariff) || unref(tariffs)?.[0]);

    const changeTariff = (tariff: IHotelOfferTariff) => {
        selectedTariff.value = tariff;
    };

    const createQuote = () => {
        quoteInProgress.value = true;
        ctx?.$emit('hotel-offer-tariff-selected', unref(currentTariff));
    };

    return {
        changeTariff,
        selectedTariff,
        currentTariff,
        quoteInProgress,
        createQuote,
    };
};